import { Injectable, Type } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import scrollLock from 'scroll-lock';
import { AbstractModalContentComponent } from './abstract-modal-content.component';
// import * as ModalActions from '@ibe/store/actions/modal.actions';
// import { Store } from '@ngrx/store';
// import * as fromStore from '../../../store';

@Injectable({ providedIn: 'root' })
export class ModalService {

	isOpen: BehaviorSubject<boolean>;
	$data: BehaviorSubject<any>;
	hostedComponent: BehaviorSubject<any>;
	params: any[];
	htmlElement = document.getElementsByTagName('html');
	
	navigateAwaySelection$: Subject<boolean> = new Subject<boolean>();

	constructor(/*private store: Store<fromStore.State>*/) {
		this.isOpen = new BehaviorSubject(false);
		this.$data = new BehaviorSubject(false);
		this.hostedComponent = new BehaviorSubject(null);
		this.params = null;
	}

	assignComponent(component: Type<AbstractModalContentComponent>, ...params: any[]) {
		this.params = params;
		this.hostedComponent.next(component);
	}

	open() {
		this.isOpen.next(true);
		// Disable scroll on body
		this.htmlElement[0].classList.add('no-scroll');
		scrollLock.hide();
	}

	close(data: any = false) {
		// this.store.dispatch(new ModalActions.ResetAction());
		this.$data.next(data);
		this.isOpen.next(false);
		this.hostedComponent.next(null);
		// Enable scroll on body again
		this.htmlElement[0].classList.remove('no-scroll');
		scrollLock.clearQueue().show();
	}
	
	// added to handle business logic that needs to happen via callback passed into params
	handleOverlayClick() {
		if (this.params && this.params[0] && this.params[0].handleOverlayClick) {
			this.params[0].handleOverlayClick(); 
		}
	}
}
